// grocery.ts
export const groceryData = [
  {
    id: "01",
    titleKey: "grocery.step1.title",
    descriptionKey: "grocery.step1.description",
  },
  {
    id: "02",
    titleKey: "grocery.step2.title",
    descriptionKey: "grocery.step2.description",
  },
  {
    id: "03",
    titleKey: "grocery.step3.title",
    descriptionKey: "grocery.step3.description",
  },
];
